if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.track = this.querySelector('[data-modal-track]');
        this.slides = Array.from(this.querySelectorAll('[data-modal-slide]'));
        this.previousButton = this.querySelector('[data-modal-previous]');
        this.nextButton = this.querySelector('[data-modal-next]');
        this.currentCounter = this.querySelector('[data-modal-current]');
        this.totalCounter = this.querySelector('[data-modal-total]');
        this.activeIndex = 0;
        this.scrollFrame = null;

        [this.previousButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goToSlide(this.activeIndex - 1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goToSlide(this.activeIndex + 1);
        });

        this.track?.addEventListener('scroll', () => {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.syncIndexFromScroll());
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToSlide(this.activeIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToSlide(this.activeIndex + 1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.track || !this.slides.length) return;

        const requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        const requestedIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === requestedMediaId);
        this.activeIndex = requestedIndex >= 0 ? requestedIndex : 0;

        this.slides.forEach((slide, index) => {
          slide.classList.toggle('active', index === this.activeIndex);
        });

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.goToSlide(this.activeIndex, false);
          });
        });
      }

      goToSlide(index, smooth = true) {
        if (!this.track || !this.slides.length) return;

        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[nextIndex];
        if (!slide) return;

        this.activeIndex = nextIndex;
        window.pauseAllMedia();

        this.slides.forEach((item, itemIndex) => {
          item.classList.toggle('active', itemIndex === nextIndex);
        });

        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto',
        });

        const deferredMedia = slide.querySelector('deferred-media');
        const template = deferredMedia?.querySelector('template');
        if (deferredMedia && template?.content?.querySelector('.js-youtube')) {
          deferredMedia.loadContent(false);
        }

        this.updateControls();
      }

      syncIndexFromScroll() {
        if (!this.track || !this.slides.length || !this.track.clientWidth) return;

        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - this.track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex === this.activeIndex) return;

        this.activeIndex = closestIndex;
        window.pauseAllMedia();

        this.slides.forEach((slide, index) => {
          slide.classList.toggle('active', index === closestIndex);
        });

        this.updateControls();
      }

      updateControls() {
        if (this.currentCounter) this.currentCounter.textContent = String(this.activeIndex + 1);
        if (this.totalCounter) this.totalCounter.textContent = String(this.slides.length);

        if (this.previousButton) this.previousButton.disabled = this.activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.activeIndex === this.slides.length - 1;
      }
    }
  );
}
